import { render, staticRenderFns } from "./AppLogo.vue?vue&type=template&id=d89d3080&"
import script from "./AppLogo.vue?vue&type=script&lang=ts&"
export * from "./AppLogo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports